import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

const moreText = [
  'To jest przykładowa umowa.',
  'jsPDF likes arrays for sentences.',
  'Do paragraphs wrap properly?',
  'Yes, they do!',
  'What does it look like?',
  'Not bad at all.',
];

const text1 = () => `
Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean pulvinar sit amet leo non pulvinar. Proin nec nulla ac sem maximus iaculis. Nulla facilisi. Nulla eget augue posuere, ornare elit et, venenatis elit. In eu euismod neque, a feugiat purus. Mauris faucibus mauris finibus urna tempor, et pharetra tortor porttitor. In viverra velit et interdum aliquam. Donec ut eleifend ante. Quisque vitae diam sit amet arcu tempor rhoncus. Duis urna purus, molestie a neque vel, facilisis fermentum neque.`;

export const generateContract = (data) => {
  const columns = [
    { title: 'Pole', dataKey: 'title' },
    { title: 'Wartosc', dataKey: 'body' },
  ];

  const items = [];

  items.push({ title: 'Imie i nazwisko', body: data.name_surname });
  items.push({ title: 'Drugie imie', body: data.second_name });
  items.push({ title: 'Adres', body: data.address });
  items.push({ title: 'Mieszkanie', body: data.flat_number });
  items.push({ title: 'Miasto', body: data.city });
  items.push({ title: 'PESEL', body: data.pesel });
  items.push({ title: 'Numer telefonu', body: data.phone });
  items.push({ title: 'Numer kierunkowy', body: data.dial_code });
  items.push({ title: 'Kod pocztowy', body: data.postal_code });
  items.push({ title: 'Wiadomosc', body: data.message });

  const doc = new jsPDF({
    orientation: 'portrait',
    unit: 'in',
    format: 'letter',
  });
  // text is placed using x, y coordinates
  doc.setFontSize(16).text('Umowa', 0.5, 1.0);

  doc.setFontSize(16).text(text1(), 0.5, 1.0);

  // create a line under heading
  // doc.setLineWidth(0.01).line(0.5, 1.1, 8.0, 1.1);
  // Using autoTable plugin
  // doc.autoTable({
  //   columns,
  //   body: items,
  //   margin: { left: 0.5, top: 1.25 },
  // });
  // Using array of sentences
  doc
    .setFontSize(12)
    .text(moreText, 0.5, 3.5, { align: 'left', maxWidth: '7.5' });

  // Creating footer and saving file
  // doc.save(`umowa-wspolpracy.pdf`);

  const pdfString = doc.output('blob');
  const blobFile = new File(
    [pdfString],
    `umowa-współpracy-${data.name_surname.replaceAll(' ', '-')}.pdf`,
    {
      type: 'text/plain',
    }
  );

  return blobFile;
};
